import { useIssueRefreshServiceStore } from './context';

export const useIssueRefreshServiceActions = () => {
	const [, { setEvent, setEventAsReported }] = useIssueRefreshServiceStore();
	return [undefined, { setEvent, setEventAsReported }] as const;
};

export const useIssueRefreshData = () => {
	const [
		{
			events: { REALTIME },
		},
	] = useIssueRefreshServiceStore();
	return { REALTIME };
};

export const useOnDemandIssueRefreshTime = () => {
	const [
		{
			events: { ON_DEMAND },
		},
	] = useIssueRefreshServiceStore();
	return ON_DEMAND?.timestamp || 0;
};
